import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const MicrosoftTeamsIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props} customFill={preserveColor}>
    <g clipPath="url(#teams-a)">
      <path
        fill="#5059C9"
        d="M20.74 13.25h6.2c.585 0 1.06.468 1.06 1.045v5.564c0 2.121-1.745 3.841-3.898 3.841h-.018c-2.152 0-3.898-1.719-3.898-3.84v-6.064a.55.55 0 0 1 .554-.546Zm4.19-1.1c1.387 0 2.512-1.108 2.512-2.475S26.317 7.2 24.93 7.2s-2.51 1.108-2.51 2.475 1.124 2.475 2.511 2.475Z"
      />
      <path
        fill="#7B83EB"
        d="M17.116 12.15c2.004 0 3.628-1.6 3.628-3.575C20.744 6.601 19.12 5 17.116 5c-2.003 0-3.628 1.6-3.628 3.575 0 1.974 1.625 3.575 3.628 3.575Zm4.837 1.1H11.721a1.04 1.04 0 0 0-1.024 1.058v6.346c-.08 3.422 2.667 6.262 6.14 6.346 3.473-.084 6.22-2.924 6.14-6.346v-6.346a1.04 1.04 0 0 0-1.024-1.058Z"
      />
      <path
        fill="#000"
        d="M17.395 13.25v8.893a1.013 1.013 0 0 1-.636.93c-.122.05-.253.077-.385.077h-5.185a6.606 6.606 0 0 1-.491-2.497v-6.347a1.04 1.04 0 0 1 1.02-1.056h5.677Z"
        opacity=".1"
      />
      <path
        fill="#000"
        d="M16.837 13.25v9.444c0 .13-.026.259-.078.379a1.03 1.03 0 0 1-.943.627H11.45a7.1 7.1 0 0 1-.262-.55 5.407 5.407 0 0 1-.196-.55 6.606 6.606 0 0 1-.295-1.947v-6.347a1.04 1.04 0 0 1 1.02-1.056h5.12Z"
        opacity=".2"
      />
      <path
        fill="#000"
        d="M16.837 13.25v8.343a1.022 1.022 0 0 1-1.021 1.007h-4.823a6.606 6.606 0 0 1-.295-1.947v-6.347a1.04 1.04 0 0 1 1.02-1.056h5.12Z"
        opacity=".2"
      />
      <path
        fill="#000"
        d="M16.279 13.25v8.343a1.022 1.022 0 0 1-1.021 1.007h-4.265a6.606 6.606 0 0 1-.295-1.947v-6.347a1.04 1.04 0 0 1 1.02-1.056h4.56Z"
        opacity=".2"
      />
      <path
        fill="#000"
        d="M17.395 10.406v1.733a4.336 4.336 0 0 1-.279.011c-.095 0-.184-.005-.279-.011a3.105 3.105 0 0 1-.558-.088 3.614 3.614 0 0 1-2.511-2.101 3.027 3.027 0 0 1-.18-.55h2.786c.563.002 1.02.452 1.021 1.006Z"
        opacity=".1"
      />
      <path
        fill="#000"
        d="M16.837 10.956v1.183a3.096 3.096 0 0 1-.558-.088 3.614 3.614 0 0 1-2.511-2.101h2.048c.563.002 1.02.451 1.021 1.006Z"
        opacity=".2"
      />
      <path
        fill="#000"
        d="M16.837 10.956v1.183a3.096 3.096 0 0 1-.558-.088 3.614 3.614 0 0 1-2.511-2.101h2.048c.563.002 1.02.451 1.021 1.006Z"
        opacity=".2"
      />
      <path
        fill="#000"
        d="M16.28 10.957v1.094a3.614 3.614 0 0 1-2.512-2.101h1.49c.563.002 1.02.452 1.021 1.007Z"
        opacity=".2"
      />
      <path
        fill="url(#teams-b)"
        d="M5.023 9.95h10.233c.565 0 1.023.451 1.023 1.008v10.084c0 .557-.458 1.008-1.023 1.008H5.023A1.016 1.016 0 0 1 4 21.042V10.958c0-.557.458-1.008 1.023-1.008Z"
      />
      <path
        fill="#fff"
        d="M12.832 13.788h-2.045v5.489H9.483v-5.49H7.447v-1.064h5.385v1.065Z"
      />
    </g>
    <defs>
      <linearGradient
        id="teams-b"
        x1="6.133"
        x2="13.971"
        y1="9.162"
        y2="22.937"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5A62C3" />
        <stop offset=".5" stopColor="#4D55BD" />
        <stop offset="1" stopColor="#3940AB" />
      </linearGradient>
      <clipPath id="teams-a">
        <path fill="#fff" d="M4 5h24v22H4z" />
      </clipPath>
    </defs>
  </BaseIcon>
);
